import * as React from 'react';
import {
  Box, Grid, Typography,
} from '@mui/material';
import { CloseSquareIcon, UploadIcon } from 'assets/icons';

import { UploadResponse, UploadScenarios } from 'interfaces/file-uploader';
import { handleContentDataDelete } from 'utils/file-uploader';
import { ErrorMessage, IconLoadingButton } from 'components/molecules';
import PrimaryTextField from 'components/molecules/custom-text-field';
import { IUpdateProfileForm } from 'pages/profile/components/profile-update/interface';
import { DeepRequired, FieldErrorsImpl } from 'react-hook-form';
import useFileUpload from 'base/core/hooks/use-file-upload';

interface SponsorLogoUploaderProps {
  index:number;
  label:string;
  imageLabel:string;
  textFieldLabel:string;
  currentImageUrl:string;
  currentText:string;
  scenario:UploadScenarios;
  handleRemove: (index:number)=>void;
  handleFile: (index:number, res:UploadResponse)=> void;
  handleInputChange: (index:number, input:string)=> void;
  errors: FieldErrorsImpl<DeepRequired<IUpdateProfileForm>>;
}

const SponsorLogoUploader = ({
  index, label,
  imageLabel, textFieldLabel, currentImageUrl, scenario,
  currentText, handleInputChange, handleRemove, handleFile, errors,
}:SponsorLogoUploaderProps) => {
  const [imageUrl, setImageUrl] = React.useState(currentImageUrl);
  const hiddenFileInput:any = React.useRef(null);
  const [uploading, setUploading] = React.useState(false);
  const { progress, handleContentDataUpload } = useFileUpload();

  const handleRemoveWrapper = async () => {
    await handleContentDataDelete(imageUrl, scenario);
    handleRemove(index);
  };
  const handleInputChangeWrapper = (event:any) => {
    handleInputChange(index, event.target.value);
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const handleChange = async (e:any) => {
    setUploading(true);
    const res = await handleContentDataUpload(e, currentImageUrl, scenario);
    setTimeout(() => {
      setImageUrl(res.url);
      handleFile(index, res);
      setUploading(false);
    }, 3000);
  };

  return (
    <div className="col-md-6">
      <div className="form-item">
        <div className="mb-1">
          <Typography variant="body1">{label}</Typography>
        </div>
        <div className="mb-1">
          <Grid container justifyContent="flex-start" alignItems="center">
            <Grid item xs="auto" className="grid-item">
              {imageUrl === '' ? (
                <Box
                  sx={{
                    backgroundColor: '#F2F2F2',
                    height: '65px',
                    width: '184px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #E7E7F1',
                    borderRadius: '6px',
                  }}
                >
                  <Typography variant="h6">{imageLabel}</Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    backgroundColor: '#F2F2F2',
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '65px',
                    width: '184px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #E7E7F1',
                    borderRadius: '6px',
                  }}
                />
              ) }
            </Grid>
            <Grid
              item
              xs="auto"
              className="grid-item mt-2"
              sx={{
                mb: (errors?.sponsors && errors.sponsors[index]?.url) ? '0' : '27px',
              }}
            >
              <IconLoadingButton
                startIcon={<UploadIcon />}
                loading={uploading}
                onClick={handleClick}
                sx={{ mr: 2 }}
              >
                Upload new
              </IconLoadingButton>
              <IconLoadingButton
                startIcon={<CloseSquareIcon />}
                onClick={handleRemoveWrapper}
                sx={{ textTransform: 'capitalize' }}
              >
                Remove
              </IconLoadingButton>
              <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: 'none' }}
              />
            </Grid>
          </Grid>
          <div>
            <ErrorMessage>
              {errors?.sponsors ? errors?.sponsors[index]?.url?.message : ''}
            </ErrorMessage>
          </div>
        </div>
        <Typography variant="body1">{textFieldLabel}</Typography>
        <div className="form-item">
          <PrimaryTextField value={currentText} onChange={handleInputChangeWrapper} />
        </div>
        <ErrorMessage>
          {errors?.sponsors ? errors?.sponsors[index]?.contentUrl?.message : ''}
        </ErrorMessage>
      </div>
    </div>
  );
};
export default SponsorLogoUploader;
